import clsx from 'clsx';
import Image from 'components/ui/Image';
import { sanitizeContentfulBlockId } from 'utils/contentful';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';
import styles from './IconRow.module.scss';
import type { InspectorPropsType } from 'hooks/useLivePreview';
import type { IBlockIconRowFields } from 'types/contentful/generated';

type Props = IBlockIconRowFields & {
  inspectorProps?: InspectorPropsType;
};

const IconRow = ({
  blockId,
  title,
  icons,
  inspectorProps,
}: Props): JSX.Element => {
  // eslint-disable-next-line
  // @ts-ignore
  const iconItems = icons.items ? icons.items : icons;

  const gridCols = ((length) => {
    switch (length) {
      case 1:
        return 'lg:grid-cols-1';
      case 2:
        return 'lg:grid-cols-2';
      case 3:
        return 'lg:grid-cols-3';
      case 4:
        return 'lg:grid-cols-4';
      case 5:
        return 'lg:grid-cols-5';
    }
  })(iconItems.length);

  return (
    <div id={sanitizeContentfulBlockId(blockId)} className={styles.wrapper}>
      <div className={styles.container}>
        {title && (
          <h2
            className={styles.headline}
            {...inspectorProps?.({ fieldId: 'title' })}
          >
            {title}
          </h2>
        )}
        <div className={clsx(styles.grid, gridCols)}>
          {
            // eslint-disable-next-line
            // @ts-ignore
            iconItems.map((item, i) => {
              const inspectorPropsForIcons = useContentfulInspectorMode({
                entryId: item?.sys?.id,
              });

              const {
                description,
                icon,
                title: itemTitle,
              } = item.fields || item;

              const imageDescription = icon?.fields?.description;
              const imageTitle = icon?.fields?.title;

              return (
                <div key={i} className={styles.item}>
                  <div
                    className={styles.imageWrapper}
                    {...inspectorPropsForIcons?.({ fieldId: 'icon' })}
                  >
                    <Image
                      className={styles.image}
                      src={icon?.fields?.file.url || icon?.url}
                      alt={imageDescription || imageTitle || ''}
                      width={100}
                      height={100}
                    />
                  </div>
                  <div className={styles.content}>
                    <h3 {...inspectorPropsForIcons?.({ fieldId: 'title' })}>
                      {itemTitle}
                    </h3>
                    <p
                      className={styles.description}
                      {...inspectorPropsForIcons?.({ fieldId: 'description' })}
                    >
                      {description}
                    </p>
                  </div>
                </div>
              );
            })
          }
        </div>
      </div>
    </div>
  );
};

export default IconRow;
